import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { EProductCategoryImageType, IProductCategoryTreeGetQuery, IProductCategoryTreeGetQueryResult, ProductCategoryDetailGetQueryResult, ProductCategoryImageGetQueryResult } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IProductCategoryApiService {

  abstract productCategoryTreeGet(
    params?: Partial<IProductCategoryTreeGetQuery>,
    allowCancellation?: boolean | undefined
  ): Observable<IProductCategoryTreeGetQueryResult>

  abstract productCategoryImageGet(productCategoryImageType: EProductCategoryImageType, categoryKeyList?: string[] | undefined, useCancellationLogic?: boolean | undefined): Observable<ProductCategoryImageGetQueryResult>;

  abstract productCategoryDetailGet(categoryKey?: string | undefined): Observable<ProductCategoryDetailGetQueryResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductCategoryApiServiceToken = new InjectionToken<IProductCategoryApiService>('IProductCategoryApiServiceToken');
